import "./IconCalculator.scss";
import { ReactComponent as CalculatorIcon } from "./svg/calculator.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconCalculator = (props: Props) => {
  const { color = "black" } = props;
  return (
    <span className={`IconCalculator IconCalculator${color}`}>
      <CalculatorIcon />
    </span>
  );
};
